var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { VPAAS_TENANT_PREFIX } from './constants';
import logger from './logger';
/**
 * Returns the full vpaas tenant if available, given a path.
 *
 * @param {string} path - The meeting url path.
 * @returns {string}
 */
function extractVpaasTenantFromPath(path) {
    const [, tenant] = path.split('/');
    if (tenant.startsWith(VPAAS_TENANT_PREFIX)) {
        return tenant;
    }
    return '';
}
/**
 * Returns the vpaas tenant.
 *
 * @param {IReduxState} state - The global state.
 * @returns {string}
 */
export function getVpaasTenant(state) {
    var _a, _b;
    return extractVpaasTenantFromPath((_b = (_a = state['features/base/connection'].locationURL) === null || _a === void 0 ? void 0 : _a.pathname) !== null && _b !== void 0 ? _b : '');
}
/**
 * Returns true if the current meeting is a vpaas one.
 *
 * @param {IReduxState} state - The state of the app.
 * @returns {boolean}
 */
export function isVpaasMeeting(state) {
    var _a, _b;
    const connection = state['features/base/connection'];
    if ((_a = connection === null || connection === void 0 ? void 0 : connection.locationURL) === null || _a === void 0 ? void 0 : _a.pathname) {
        return Boolean(extractVpaasTenantFromPath((_b = connection === null || connection === void 0 ? void 0 : connection.locationURL) === null || _b === void 0 ? void 0 : _b.pathname));
    }
    return false;
}
/**
 * Sends a request for retrieving jaas customer details.
 *
 * @param {Object} reqData - The request info.
 * @param {string} reqData.appId - The client appId.
 * @param {string} reqData.baseUrl - The base url for the request.
 * @returns {void}
 */
export function sendGetDetailsRequest({ appId, baseUrl }) {
    return __awaiter(this, void 0, void 0, function* () {
        const fullUrl = `${baseUrl}/v1/public/tenants/${encodeURIComponent(appId)}`;
        try {
            const res = yield fetch(fullUrl);
            if (res.ok) {
                return res.json();
            }
            throw new Error('Request not successful');
        }
        catch (err) {
            throw new Error(err);
        }
    });
}
/**
 * Returns the billing id for vpaas meetings.
 *
 * @param {IReduxState} state - The state of the app.
 * @param {string} feature - Feature to be looked up for disable state.
 * @returns {boolean}
 */
export function isFeatureDisabled(state, feature) {
    return state['features/jaas'].disabledFeatures.includes(feature);
}
/**
 * Sends a request for retrieving jaas JWT.
 *
 * @param {Object} reqData - The request info.
 * @param {string} reqData.appId - The client appId.
 * @param {string} reqData.baseUrl - The base url for the request.
 * @returns {void}
 */
export function sendGetJWTRequest({ appId, baseUrl }) {
    return __awaiter(this, void 0, void 0, function* () {
        const fullUrl = `${baseUrl}/v1/public/token/${encodeURIComponent(appId)}`;
        try {
            const res = yield fetch(fullUrl, {
                method: 'GET'
            });
            if (res.ok) {
                return res.json();
            }
            throw new Error('Request not successful');
        }
        catch (err) {
            throw new Error(err);
        }
    });
}
/**
 * Gets a jaas JWT.
 *
 * @param {IReduxState} state - Redux state.
 * @returns {string} The JWT.
 */
export function getJaasJWT(state) {
    return __awaiter(this, void 0, void 0, function* () {
        const baseUrl = state['features/base/config'].jaasTokenUrl;
        const appId = getVpaasTenant(state);
        const shouldSendRequest = Boolean(baseUrl && appId);
        if (shouldSendRequest) {
            try {
                const jwt = yield sendGetJWTRequest({
                    appId,
                    baseUrl: baseUrl !== null && baseUrl !== void 0 ? baseUrl : ''
                });
                return jwt.token;
            }
            catch (err) {
                logger.error('Could not send request', err);
            }
        }
    });
}
